import { directoryLogoPath, defaultLogoPath, mapBrands } from './BrandMapping'

const classNameJobTile: string = 'attrax-vacancy-tile'
    const classNameShortlistBtn: string = `${classNameJobTile}__shortlist`
    const classNameContainerLogo: string = `${classNameJobTile}__container-logo`
    const classNameContainerDetails: string = `${classNameJobTile}__container-details`
    const classNameLogo: string = `${classNameJobTile}__logo`
    const classNameOptionBrand: string = `${classNameJobTile}__option-brand`
    const classNameDetails: Array<string> = [
        `${classNameJobTile}__description`,
        `${classNameJobTile}__salary`,
        `${classNameJobTile}__reference`,
        `${classNameJobTile}__expiry`,
        `${classNameJobTile}__location-freetext`,
        `${classNameJobTile}__option-department`,
        `${classNameJobTile}__option-job-type`,
        `${classNameJobTile}__option-location`,
        `${classNameJobTile}__option-brand`,
    ]

export const initialise = () => {
    const jobTiles: NodeListOf<HTMLDivElement> = document.querySelectorAll(`.${classNameJobTile}`)
    if (!jobTiles) return

    logoContainer(jobTiles)
    // moveDetails(jobTiles)
    updateLogo()
    initShortlistAria()
    initApplyAria()
}

const initShortlistAria = () => {
    const shortlistBtns = document.querySelectorAll<HTMLElement>(`.${classNameShortlistBtn}`)
    shortlistBtns.forEach((btn) => {
        const jobTitle = btn.closest<HTMLElement>(`.${classNameJobTile}`)?.querySelector<HTMLElement>(`.${classNameJobTile}__title`)
        btn.setAttribute('aria-label', `Shortlist ${jobTitle?.textContent ?? 'job'}`)
        btn.setAttribute('aria-pressed', btn.classList.contains('shortlisted') ? 'true' : 'false')

        new MutationObserver(() => {
            btn.setAttribute('aria-pressed', btn.classList.contains('shortlisted') ? 'true' : 'false')
        }).observe(btn, { attributes: true, attributeFilter: ['class'] })
    })
}

const initApplyAria = () => {
    const applyBtns = document.querySelectorAll<HTMLElement>(`.${classNameJobTile}__learn-more`)
    applyBtns.forEach((btn) => {
        const jobTitle = btn.closest<HTMLElement>(`.${classNameJobTile}`)?.querySelector<HTMLElement>(`.${classNameJobTile}__title`)
        btn.setAttribute('aria-label', `Apply for ${jobTitle?.textContent ?? 'job'}`)
    })
}

const logoContainer = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerLogo)
        jobTile.prepend(container)

        let logo: HTMLImageElement = document.createElement('img')
        logo.alt = ''
        logo.loading = 'lazy'
        logo.height = 40
        logo.width = 300
        logo.src = defaultLogoPath
        logo.className = classNameLogo
        container.appendChild(logo)
    })
}

const moveDetails = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerDetails)
        jobTile.appendChild(container)

        const detailsSelector: string = classNameDetails.map(className => `.${className}`).join(', ')
        const details = jobTile.querySelectorAll<HTMLElement>(detailsSelector)
        details.forEach((detail: HTMLElement) => {
            container.appendChild(detail)
        })
    })
}

const updateLogo = () => {
    mapBrands.forEach((fileType: string, fileName: string) => {
        const classNameBrand: string = `.${classNameOptionBrand}--${fileName}`

        let brandFileName: string = `${fileName}.${fileType}`
        const filePath: string = `${directoryLogoPath}/${brandFileName}`
        const brandOptions: NodeListOf<HTMLElement> = document.querySelectorAll(classNameBrand)

        brandOptions.forEach((brandOption: HTMLElement) => {
            const jobTile = brandOption.closest<HTMLElement>(`.${classNameJobTile}`)
            if (!jobTile) return
            const container = jobTile.querySelector<HTMLElement>(`.${classNameContainerLogo}`)
            if (!container) return
            const logo = container.querySelector<HTMLImageElement>('img')
            if (!logo) return
            logo.src = filePath
        })
    })
}